const shownWarnings = new Set();
const pendingWarnings = new Set();
const storageKey = (id) => `pfWarningShown:${id}`;

const warningShown = (id) => {
  if (!id) return false;
  if (shownWarnings.has(id)) return true;
  try {
    return sessionStorage.getItem(storageKey(id)) === 'true';
  } catch (_) {
    return false;
  }
};

const markShown = (id) => {
  if (!id) return;
  shownWarnings.add(id);
  try {
    sessionStorage.setItem(storageKey(id), 'true');
  } catch (_) {}
};

// Shared by cable, persisted-page replay, and polling. Failed requests remain
// retryable; duplicate updates must not replace a form the user is filling in.
export const openMissingPfScreen = (designations, payrollRunId) => {
  if (!Array.isArray(designations) || !designations.length) return false;
  payrollRunId = payrollRunId ? String(payrollRunId) : null;
  if (warningShown(payrollRunId)) return true;
  if (pendingWarnings.has(payrollRunId)) return false;

  pendingWarnings.add(payrollRunId);
  $('.salary-operation-status').addClass('d-none');
  $.ajax({
    type: 'GET',
    dataType: 'script',
    url: '/pf_percentages/new',
    data: { designations: designations },
    success() {
      const modal = $('.payroll_sheet_warnings_modal');
      if (modal.hasClass('show')) {
        markShown(payrollRunId);
      } else {
        // The response may first wait for the generation modal to close.
        modal.one('shown.bs.modal', () => markShown(payrollRunId));
      }
    },
    complete() {
      pendingWarnings.delete(payrollRunId);
    }
  });
  return false;
};
